import { useSelector } from 'react-redux'
import AddToCartPopover from './popovers/AddToCartPopover'
import BackgroundPopover from './popovers/BackgroundPopover'
import BaseModelsPopover from './popovers/BaseModelsPopover'
import CompatibilityPopover from './popovers/CompatibilityPopover'
import ComponentHoverPopover from './popovers/ComponentHoverPopover'
import ComponentTogglePopover from './popovers/ComponentTogglePopover'
import FullPaintPopover from './popovers/FullPaintPopover'
import GetQuotePopover from './popovers/GetQuotePopover'
import InfoPopover from './popovers/InfoPopover'
import InquiryPopover from './popovers/InquiryPopover'
import OptionColorPopover from './popovers/OptionColorPopover'
import OptionsPopover from './popovers/OptionsPopover'
import PresetsPopover from './popovers/PresetsPopover'
import SettingsPopover from './popovers/SettingsPopover'
import SharePopover from './popovers/SharePopover'
import SpecificationPopover from './popovers/SpecificationPopover'
import UncombinablePopover from './popovers/UncombinablePopover'
import VideoPopover from './popovers/VideoPopover'
import LogoPopover from './popovers/LogoPopover'

const PopoverOutlet = () => {
  const popover = useSelector((state) => state.popover)

  switch (popover) {
    case 'addToCart':
      return <AddToCartPopover />

    case 'background':
      return <BackgroundPopover />

    case 'baseModels':
      return <BaseModelsPopover />

    case 'compatibility':
      return <CompatibilityPopover />

    case 'componentHover':
      return <ComponentHoverPopover />

    case 'componentToggle':
      return <ComponentTogglePopover />

    case 'fullPaint':
      return <FullPaintPopover />

    case 'getQuote':
      return <GetQuotePopover />

    case 'info':
      return <InfoPopover />

    case 'inquiry':
      return <InquiryPopover />

    case 'logo':
      return <LogoPopover />

    case 'optionColor':
      return <OptionColorPopover />

    case 'options':
      return <OptionsPopover />

    case 'presets':
      return <PresetsPopover />

    case 'settings':
      return <SettingsPopover />

    case 'share':
      return <SharePopover />

    case 'specification':
      return <SpecificationPopover />

    case 'uncombinable':
      return <UncombinablePopover />

    case 'video':
      return <VideoPopover />

    default:
      return null
  }
}

export default PopoverOutlet
